module.exports = __webpack_public_path__ + "img/b6.9b00d8bb.webp";